import React from "react";
import AvatarGroup from "components/common/Avatar/AvatarGroup";
import {
  applyAvatarImageFallback,
  baseURLImage,
  capitalizeAllLetters,
  getNameProfile,
} from "Utils/utils";
import { adaptLiveParticipant } from "../utils/signalAdapter";

export const toAvatarData = (people = []) =>
  people.map((person, index) => ({
    uuid: person.uuid || person.id || person.initials || String(index),
    first_name: person.first_name || person.firstName,
    last_name: person.last_name || person.lastName,
    photo: person.photo || person.profile_picture,
    status: person.status,
  }));

const participantName = (person) =>
  capitalizeAllLetters(
    `${person?.firstName || person?.first_name || ""} ${
      person?.lastName || person?.last_name || ""
    }`.trim()
  );

const CareWatchParticipantCell = ({ participants = [] }) => {
  const people = (participants || [])
    .map(adaptLiveParticipant)
    .filter((person) => person.firstName || person.lastName);
  const isMulti = people.length > 1;
  const person = people[0];
  const name = participantName(person);
  const firstName = person?.first_name || person?.firstName;
  const lastName = person?.last_name || person?.lastName;
  const photo = person?.photo || person?.profile_picture;

  if (!people.length) {
    return <span className="text-[13px] font-medium text-[#94A3B8]">—</span>;
  }

  if (isMulti) {
    return (
      <div className="min-w-0">
        <AvatarGroup
          type="participant"
          arrayData={toAvatarData(people)}
          cssClass="mt-0"
          maxLength={3}
          isNoRing
        />
      </div>
    );
  }

  return (
    <div className="flex min-w-0 items-center gap-2">
      <div className="h-9 w-9 shrink-0">
        <img
          alt=""
          className="h-9 w-9 rounded-full object-cover"
          onError={(event) => applyAvatarImageFallback(event, firstName, lastName)}
          src={
            photo
              ? baseURLImage(photo)
              : getNameProfile(firstName, lastName)
          }
        />
      </div>
      <span
        className="min-w-0 truncate text-[13px] font-semibold text-[#111827]"
        title={name || undefined}
      >
        {name || "—"}
      </span>
    </div>
  );
};

export default CareWatchParticipantCell;
